export default __webpack_public_path__ + "static/media/theme10-dots-bg.7aa2177f.png";